// extracted by mini-css-extract-plugin
module.exports = {"LinkInteresContainer":"ListaLinkDeInteres_LinkInteresContainer__1oCfe","ListaLinkDeInteres":"ListaLinkDeInteres_ListaLinkDeInteres__2ab9I"};